export const ARCHIVE = 'ARCHIVE'
export const UNDO = 'UNDO'
export const INTAKE_MAX_WIDTH = 800
